<template>
  <div class="pt-60 pb-90">
    <div class="">
      <div class="page-tab pt-26 pl-80 pr-80">
        <div class="container-1752 df aic">
          <span class="active">{{ $t('驻站专家') }}</span>
          <span class="cup ml-22" @click="handleMvp('/stationed/mvp')">MVP</span>
        </div>
      </div>

      <div class="topcontent-page mt-26 pl-60 pr-60">
        <div class="container-1752">
          <div class="t2">{{ $t('驻站专家') }}</div>
          <div class="desc1 break-word">
            {{
            $t('驻站专家是通过申请或邀约')
          }}

          </div>
        </div>

        <div class="person-list">
          <swiper :options="swiperOption">

            <!-- listdata  数量大于10 -->


            <swiper-slide v-for="(item, index) in numbers" :key="index">
              <div class="df fww leng10box">
                <div v-for="(items, indexs) in numbers[index]" class="leng10list" style="width: 20%">
                  <div class="list-box" :class="{ 'list-boxend': items.have_be_follow == 10 }"
                    @click="handleLink(items.user_id)">
                    <div class="list" :title="items.user_name + ' ' + items.tesa_company + ' ' + items.user_job_name">
                      <div class="img-box">
                        <img :src="items.tesa_personal_photo_arr" alt="">
                      </div>
                      <div class="text-box">
                        <div class="name one-text pb-2">{{ items.user_name }}</div>
                        <div class="company one-text">
                          <template v-if="items.tesa_company_show == 10">
                            {{ items.tesa_company }}
                          </template>
                          {{ items.user_job_name }}
                        </div>

                        <div class="country-box mt-4">
                          <span>{{ items.country_name }}</span>
                        </div>

                        <div class="desc tow-text" v-if="items.user_excel_arr.length">

                          <span v-for="(items1, index1) in items.user_excel_arr">

                            {{ items1.label }}<span v-if="index1 < items.user_excel_arr.length - 1">、</span>
                          </span>
                        </div>
                      </div>
                    </div>
                    <el-button type="primary" class="follow-btn"
                      :class="{ 'follow-btnend': items.have_be_follow == 10 }"
                      @click.stop="(event) => userfollowAdd(event, items)">
                      {{ items.have_be_follow == 10 ? $t('已关注') : `+ ${$t('关注')}` }}</el-button>
                  </div>
                </div>
              </div>

              <!-- <div class="list-box" :class="{ 'list-boxend': item.have_be_follow == 10 }"
                  @click="handleLink(items[indexs].user_id)" v-for="(items, indexs) in numbers[index]">
                  <div class="list">
                    <div class="img-box">
                      <img :src="items[indexs].tesa_personal_photo_arr" alt="">
                    </div>
                    <div class="text-box">
                      <div class="name one-text">{{ items[indexs].user_name }}</div>
                      <div class="company one-text">
                        <template v-if="items[indexs].tesa_company_show == 10">
                          {{ items[indexs].tesa_company }}
                        </template>
{{ items[indexs].user_job_name }}
</div>
<div class="desc tow-text" v-if="items[indexs].user_excel_arr.length">
  <span v-for="(items1, index1) in items[index].user_excel_arr" :key="index1">
    {{ items1.label }}<span v-if="index1 < item.user_excel_arr.length - 1">、</span>
  </span>
</div>
</div>
</div>
<el-button type="primary" class="follow-btn" :class="{ 'follow-btnend': item.have_be_follow == 10 }"
  @click.stop="(event) => userfollowAdd(event, listdata[index])">
  {{ item.have_be_follow == 10 ? $t('已关注') : `+ ${$t('关注')}` }}</el-button>
</div> -->
            </swiper-slide>


          </swiper>

          <div class="swiper-btn df aic jcc">
            <div class="swiper-button-prev" id="topic_prev"></div>
            <div class="swiper-button-next" id="topic_next"></div>

          </div>

        </div>
      </div>

      <div class="welcome-box pl-80 pr-80">
        <div class="container-1752">
          <div class="t1">- {{ $t('欢迎成为驻站专家') }} -</div>
          <div class="content-box">
            <div class="box1">
              <div class="box2">
                <div class="t2">{{ $t('驻站专家权益') }}</div>

                <div class="li-box df jcsb">
                  <div class="li f1">
                    <div class="img-box">
                      <img :src="require('../../assets/images/img/z2.png')" alt="">
                      <p class="t1 ta-c one-text break-word" :title="$t('专属聘书')">{{ $t('专属聘书') }}</p>
                      <div class="desc four-text">
                        <p class="break-word" v-html="$t('获得OceanClub驻站专家聘书')" :title="$t('获得OceanClub驻站专家聘书')"></p>
                      </div>
                    </div>
                  </div>


                  <div class="li f1">
                    <div class="img-box">
                      <img :src="require('../../assets/images/img/z6.png')" alt="">
                      <p class="t1 ta-c one-text break-word" :title="$t('社区展播')">{{ $t('社区展播') }}</p>
                      <div class="desc four-text">
                        <p class="break-word" :title="$t('驻站专家展示页,内容包含简介,照片,文章等')">{{ $t('驻站专家展示页,内容包含简介,照片,文章等') }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="li f1">
                    <div class="img-box">
                      <img :src="require('../../assets/images/img/z1.png')" alt="">
                      <p class="t1 ta-c one-text break-word" :title="$t('获得积分')">{{ $t('获得积分') }}</p>
                      <div class="desc four-text">
                        <p class="break-word" :title="$t('通过特约撰稿、专题演讲等方式')">{{ $t('通过特约撰稿、专题演讲等方式') }}</p>
                      </div>
                    </div>
                  </div>

                  <div class="li f1">
                    <div class="img-box">
                      <img :src="require('../../assets/images/img/z3.png')" alt="">
                      <p class="t1 ta-c one-text break-word" :title="$t('大咖面对面')">{{ $t('大咖面对面') }}</p>
                      <div class="desc four-text">
                        <p class="break-word" :title="$t('与技术专家、行业大咖交流学习并扩大个人影响力')">{{ $t('与技术专家、行业大咖交流学习并扩大个人影响力') }}</p>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="li f1">
                  <div class="img-box">
                    <img :src="require('../../assets/images/img/z4.png')" alt="">
                    <p class="t1 ta-c break-word">{{ $t('媒体采访') }}</p>
                  </div>
                </div> -->
                  <div class="li f1">
                    <div class="img-box">
                      <img :src="require('../../assets/images/img/z5.png')" alt="">
                      <p class="t1 ta-c one-text break-word" :title="$t('共享创新成果')">{{ $t('共享创新成果') }}</p>
                      <div class="desc four-text">
                        <p class="break-word" :title="$t('如研究报告、白皮书、学术合作、企业IT项目等')">{{ $t('如研究报告、白皮书、学术合作、企业IT项目等') }}</p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="bt-img pl-80 pr-80" style=''>
      <!--  心目中的驻站专家-->
      <div class="center-stationed container-1752 pt-40">
        <div class="t1">{{ $t('心目中的驻站专家') }}</div>

        <div class="li-box df fww">
          <div class="li" v-for="(item, index) in experData" :key="index">
            <img class="bg" :src="item.img" alt="">
            <div class="text-box df aife">
              <!-- {{ $t(item.title) }} -->
              <p class="p2 three-text break-word" :title="$t(item.title)" v-html="$t(item.title)"></p>
            </div>
          </div>

        </div>

        <div class="df jcc">
          <el-button class="btn" type="primary" @click="handleApplication()">{{ $t('报名成为驻站专家') }}</el-button>
        </div>

        <div class="prompt df jcc">
          {{ $t('提交申请') }} > {{ $t('提供材料') }} > {{ $t('社区审核') }} > {{ $t('公布结果') }}
        </div>
      </div>

      <!-- 专家动态 -->

      <div class="updates-box ">
        <div class="container-1752">
          <div class="t1 ta-c">{{ $t('专家动态') }}</div>
          <div class="updates-contentbox">
            <div style="background-color: #ffffff;position: relative;z-index: 10;border-radius: 10px;">

              <div class="updates-content mt-49 df fww" :class="{ 'towline-box': articles.length % 2 == 0 }">
                <template v-if="articles.length == 0">
                  <div class="no-data">
                    <img src="@/assets/images/empty_data.png" alt="">
                    <p>{{ $t('暂无数据') }}</p>
                  </div>
                </template>
                <template v-else>
                  <div class="li cup" v-for="(article, index) in articles" :key="index"
                    @click="handleArticleLink(article)">
                    <div class="title one-text">
                      <span>【{{ article.compose_type === 10 ? $t('帖子') : $t('文章') }}】</span>{{ article.title }}
                    </div>
                    <div class="desc tow-text">
                      {{ article.article_desc }}
                    </div>
                    <div class="df jcsb mt-12">
                      <div class="df">
                        <div class="fn df mt-3">
                          <img @click="(event) => handleaAvatar(event, article)" class="avatar"
                            :src="article.tesa_personal_photo_arr" alt="">
                          <div class="name fn">{{ article.user_name }}</div>
                        </div>
                        <!--                <template v-if="article.user_excel_arr.length">-->
                        <!--                  <div class="type" v-if="article.user_excel_arr">-->
                        <!--                    <span v-for="items1 in article.user_excel_arr">{{ items1.label }}</span>-->
                        <!--                  </div>-->
                        <!--                </template>-->

                      </div>

                      <div class="df fn">
                        <div class="ls"><span class="iconfont">&#xe611;</span>{{ article.hits }}</div>
                        <div class="ls"><span class="iconfont">&#xe61b;</span>{{ article.likes }}</div>
                        <div class="ls"><span class="iconfont">&#xe63e;</span>{{ article.reply_count }}</div>
                        <div class="date">{{ article.create_time }}</div>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>


    <!-- 个人信息 -->
    <avatarTop ref="avatarDialog" @post-submitted="handleAvatarSubmitted" :id="id" />
  </div>

</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import { getDynamicList, getExpertList, applyDetail } from "@api/expert";
import { setuserfollowAdd } from "@api/home";

export default {
  components: { Swiper, SwiperSlide },

  data() {
    return {
      numbers: [],
      language: localStorage.getItem('currentLanguage'),
      id: 0,
      user_id: 0,
      swiperOption: {
        spaceBetween: 0,
        slidesPerView: 1,
        navigation: {
          nextEl: '#topic_next',
          prevEl: '#topic_prev',
        },
      },

      listdata: [],
      articles: [],
      pagination: {
        page: 1,
        total: 0,

      },

      FormData: {

      },

      // 心目中的驻站专家
      experData: [
        { img: require('../../assets/images/img/img1.png'), title: '存储项目贡献者' },
        { img: require('../../assets/images/img/img2.png'), title: '存储峰会/论坛Speaker' },
        { img: require('../../assets/images/img/img3.png'), title: '存储专刊/书籍/案例的作者' },
        { img: require('../../assets/images/img/img4.png'), title: '存储KOL' },
        { img: require('../../assets/images/img/img5.png'), title: '获得存储技术认证证书者' },
        { img: require('../../assets/images/img/img6.png'), title: '存储行业协会领导/核心人' },
        { img: require('../../assets/images/img/img7.png'), title: '存储相关教授/影响力学者' },
        { img: require('../../assets/images/img/img8.png'), title: '热衷IT技术发展的贡献者' },
      ]
    }
  },
  mounted() {
    // 设置默认的顶部菜单背景色
    this.$bus.$emit('changeNavbg', 'rgba(255, 255, 255, 1);');

    this.getData();

  },
  methods: {
    handleArticleLink(item) {
      let Language = localStorage.getItem('currentLanguage');  //获取本地语言
      let str = "/protal";
      if (Language && Language != 'zh') {
        str = "/protal_" + Language;
      }
      if (item.compose_type == 10) {
        // const url = str + '/post/info/id/' + item.tp_id; //帖子
        // window.open(url, '_blank');
        this.$navigate('/discuss/info', item.tp_id)
      } else if (item.compose_type == 20) {
        // const url = str + '/topicarticle/info/id/' + item.ttar_id; //文章
        // window.open(url, '_blank');
        this.$navigate('/subject/info', item.ttar_id)
      }
    },

    // 
    handleMvp(path) {
      let str = '/cn';
      let Language = localStorage.getItem('currentLanguage');  //获取本地语言
      if (Language && Language != 'zh') {
        str = '/' + Language;
      }
      this.$router.push(str + path); // 使用编程式导航跳转到 About 页面
    },
    handleaAvatar(event, item) {
      event.stopPropagation(); // 阻止事件冒泡
      this.$refs.avatarDialog.openModal();
      this.id = item.user_id;
    },
    async handleAvatarSubmitted(id) {

      let res = await setuserfollowAdd({ tuf_be_follow_user_id: id });
      if (res.status == 200) {
        this.$message.success(res.msg);
      }

    },

    async userfollowAdd(event, item) {
      let res = await setuserfollowAdd({ tuf_be_follow_user_id: item.user_id });
      if (res.status === 200) {
        this.$message.success(res.msg);
        this.getData();
      }
    },

    // 初始化获取数据
    async getData() {
      const res = await getExpertList({ ...this.FormData, page: this.pagination.page });
      if (res.status == 200) {
        this.pagination.total = res.data.total;
        this.listdata = res.data.data;
      }


      if (this.listdata.length > 10) {
        this.numbers = [];
        const chunkSize = 10;
        const twoDimensionalArray = this.chunkArray(this.listdata, chunkSize);
        this.numbers = JSON.parse(JSON.stringify(twoDimensionalArray));
      } else {
        this.numbers = [
          this.listdata
        ]
      }

      const compose_res = await getDynamicList({ ...this.FormData, page: this.pagination.page });
      if (compose_res.status == 200) {
        this.pagination.total = compose_res.total;
        this.articles = compose_res.data;
      }

    },

    chunkArray(array, chunkSize) {
      const result = [];
      for (let i = 0; i < array.length; i += chunkSize) {
        const chunk = array.slice(i, i + chunkSize);
        result.push(chunk);
      }
      return result;
    },

    // 跳转详情
    handleLink(user_id) {
      let str = '/cn';
      let Language = localStorage.getItem('currentLanguage');  //获取本地语言
      if (Language && Language != 'zh') {
        str = '/' + Language;
      }
      this.$router.push(str + '/stationed/info/' + user_id + "/10/10"); // 使用编程式导航跳转到 About 页面
    },
    isEmpty(value) {
      if (Array.isArray(value)) {
        return value.length === 0;
      } else if (value && typeof value === 'object') {
        return Object.keys(value).length === 0;
      }
      return value === null || value === undefined;
    },
    // 跳转申请页面
    async handleApplication() {
      let details = await applyDetail();
      let Language = localStorage.getItem('currentLanguage');  //获取本地语言
      if (details.status == 40001) {
        let str = "/protal";
        if (Language && Language != 'zh') {
          str = "/protal_" + Language;
        } else {
        }

        const parsedUrl = new URL(window.location.href);
        const path = parsedUrl.pathname; // This will give you the path

        const url = str + '/usercenter/userinfo?callback=' + path; // 你想要跳转的 URL
        window.open(url);
        return false;
      }
      let str = '/cn';
      if (Language && Language != 'zh') {
        str = '/' + Language;
      }
      if (details.status == 200 && !this.isEmpty(details.data)) {
        //跳转主页
        this.$router.push(str + '/stationed/info/' + details.data.user_id + '/60');
      } else {
        this.$router.push(str + '/stationed/application');
      }

    },
    submitPost(id) {
      setuserfollowAdd({ tuf_be_follow_user_id: id });
    },
  }
}
</script>

<style lang="scss" scoped>
.country-box{
 span{
  background: #F3F3F3;
  padding: 3px 8px;
  border-radius: 4px;
  color: #333;
  font-size: 12px;
 }
}
// ::v-deep() {
//   .swiper-slide {
//     width: calc(100% + 48px) !important;
//   }
// }

.leng10box {
  .leng10list {

    width: calc(20% - 41px) !important;
    margin-right: 40px;
  }

  .leng10list:nth-child(5n) {
    margin-right: 0;


  }
}

.swiper-container {
  width: calc(100% + 40px);
  padding-bottom: 18px;
  padding-left: 20px;
  padding-right: 12px;
  // width: calc(100% + 36px);
  // padding-left: 18px;
  // padding-right: 18px;
  // position: relative;
  // left: -18px;
}

.list-box {
  position: relative;
  box-sizing: border-box;
  // border: 1px solid transparent;
  transition: border .36s;



  &:hover {
    &.list-boxend {
      .list {
        border: 1px solid rgba(183, 37, 30, 0.6);
      }
    }

    .follow-btn {
      display: block;
      bottom: -56px;
    }

    .list {
      border: 1px solid rgb(183, 37, 30);
      border-radius: 12px 12px 0 0;
    }
  }

  // & {
  //   .follow-btn {
  //     bottom: -56px !important;
  //     display: block !important;
  //   }

  //   .list {
  //     border: 1px solid rgb(183, 37, 30) !important;
  //     border-radius: 12px 12px 0 0 !important;
  //   }
  // }

  .follow-btn {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 56px;
    background: rgb(183, 37, 30);
    color: #ffffff;
    border-radius: 0 0 12px 12px;
    z-index: 100;
    font-size: 16px;
    display: none;
    transition: all .36s;
  }

  .follow-btn.follow-btnend {
    background: rgb(183, 37, 30);
    opacity: 0.6;
  }
}

.updates-box {
  margin-top: 119px;

  &::after {
    content: "";
    display: block;

  }

  .t1 {
    color: rgb(25, 25, 25);
    font-family: "MicrosoftYaHeiSemibold";
    font-size: 32px;
    font-weight: 400;
    line-height: 36px;
  }

  .updates-contentbox {
    position: relative;
    z-index: 10;



    &::after {
      content: "";
      display: block;
      border-radius: 12px;
      // background: #B7251E;
      background: linear-gradient(180.00deg, rgba(183, 37, 30, 0.6), rgba(183, 37, 30, 0.1) 96.357%, rgba(183, 37, 30, 0.1) 100%);
      width: calc(100% + 2px);
      height: calc(100% + 2px);
      position: absolute;
      left: -1px;
      top: -1px;
    }


    &::before {
      content: "";
      border-radius: 12px;
      display: block;
      background-color: linear-gradient(180.00deg, rgba(183, 37, 30, 0.04), rgba(255, 255, 255, 0) 96.357%, rgba(196, 196, 196, 0) 100%);
      width: calc(100%);
      height: calc(100%);
      position: absolute;
      left: -0;
      top: -0;
      z-index: 1;
    }
  }

  .updates-content {
    padding: 24px;
    border-radius: 12px;
    background: linear-gradient(180.00deg, rgba(183, 37, 30, 0.04), rgba(255, 255, 255, 0) 96.357%, rgba(196, 196, 196, 0) 100%);
    position: relative;
    z-index: 10;

    .li:last-child {
      border-bottom: none;
    }

    .li:last-child {
      border-bottom: none;

      &:hover {
        border-bottom: none;
      }
    }

    &.towline-box {
      .li:nth-last-child(2) {
        border-bottom: none;

        &:hover {
          border-bottom: none;
        }
      }
    }

    .li {
      width: 50%;
      padding: 24px 16px 24px 16px;
      border-bottom: 1px solid rgb(226, 226, 226);
      transition: border-bottom 0.36s;

      &:hover {
        border-bottom: 1px solid #B7251E;

        .title {
          color: #B7251E;
        }
      }



      .avatar {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        object-fit: cover
      }

      .name {
        color: rgb(51, 51, 51);
        font-family: 'PingFang SC';
        font-size: 12px;
        font-weight: 400;
        margin-left: 8px;
      }

      .type {
        margin-left: 15px;
        padding-left: 15px;
        position: relative;

        &::after {
          content: "";
          display: block;
          width: 1px;
          height: 14px;
          background-color: #E2E2E2;
          position: absolute;
          left: 0;
          top: 5px;
        }

        span {
          display: inline-block;
          height: 22px;
          padding: 4px 6px;
          box-sizing: border-box;
          background-color: #F1F1F1;
          font-size: 11px;
          color: #868D9F;
          margin-right: 7px;
          border-radius: 3px;
        }
      }

      .ls {
        font-size: 12px;
        color: #868D9F;
        margin-left: 16px;

        .iconfont {

          font-size: 13px;
          color: #868D9F;
          margin-right: 8px;
        }
      }

      .date {
        font-size: 12px;
        color: #868D9F;
        margin-left: 22px;
        position: relative;
        padding-left: 18px;

        &::after {
          content: "";
          display: block;
          width: 1px;
          height: 11px;
          background-color: #D8D8D8;
          position: absolute;
          left: 0;
          top: 3px;
        }
      }

      .title {
        font-size: 18px;
        font-weight: 400;
        line-height: 24px;
        color: #191919;
        font-family: "MicrosoftYaHeiSemibold";

        span {
          color: #B7251E;
        }
      }

      .desc {
        color: rgb(51, 51, 51);
        font-size: 14px;
        font-weight: 400;
        line-height: 22px;
        margin-top: 8px;
      }
    }
  }
}

.bt-img {
  background-image: url("../../assets/images/stationed-bg.png");
  background-size: 100% auto;
  background-position: center 270px;
  background-repeat: no-repeat;
}

.center-stationed {



  .btn {
    min-width: 221px;
    height: 56px;
    border-radius: 40px;

    background: rgb(183, 37, 30);
    padding: 0 16px;
    font-size: 20px;
    color: rgb(255, 255, 255);

    &:hover {
      opacity: 0.8;
    }
  }

  .prompt {
    color: rgb(0, 0, 0);
    font-size: 16px;
    font-weight: 400;
    line-height: 32px;
    letter-spacing: 1px;
    margin-top: 20px;
  }

  .t1 {
    text-align: center;
    color: rgb(18, 18, 18);
    font-family: "MicrosoftYaHeiSemibold";
    font-size: 32px;
    font-weight: 400;
    line-height: 60px;
  }

  .li-box {
    margin-top: 40px;

    .li {
      width: calc(25% - 30px);
      height: 256px;
      border-radius: 12px;
      overflow: hidden;
      margin-right: 40px;
      position: relative;
      margin-bottom: 40px;


      &:hover {
        img.bg {
          transform: scale(1.1);
        }
      }

      &:nth-child(4n) {
        margin-right: 0;
      }

      img.bg {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: all 2s;
      }

      .text-box {
        height: 116px;
        position: absolute;
        width: 100%;
        bottom: 0;
        padding: 24px;
        background: linear-gradient(180.00deg, rgba(0, 0, 0, 0) 0.763%, rgb(0, 0, 0) 100%);

        p {
          color: #ffffff;
        }

        .p2 {
          color: rgb(255, 255, 255);
          font-family: "PingFang SC";
          font-size: 23px;
          font-weight: 400;
          line-height: 36px;
        }
      }
    }
  }
}

.welcome-box {
  padding-top: 62px;

  .t1 {
    font-family: "MicrosoftYaHeiSemibold";
    color: rgb(18, 18, 18);
    text-align: center;
    font-size: 44px;
    font-weight: 400;
    line-height: 60px;
  }

  .t2 {
    font-family: "MicrosoftYaHeiSemibold";
    text-align: center;
    color: rgb(18, 18, 18);
    font-size: 32px;
    font-weight: 400;
    line-height: 60px;
    letter-spacing: 0px;
  }

  .content-box {
    width: 100%;
    height: 553px;
    margin-bottom: 50px;
    margin-top: 42px;
    position: relative;
    z-index: 10;

    &::after {
      content: "";
      display: block;
      position: absolute;
      width: calc(100% + 4px);
      height: calc(100% + 4px);
      top: -2px;
      left: -2px;
      right: -2px;
      bottom: -2px;
      background: radial-gradient(circle at 60% 60%, #ffffff 0%, #fdeae9 100%);
      z-index: -1;
      border-radius: 21px;
      padding: 5px;
      box-sizing: border-box;
    }
  }

  .box1 {
    height: 553px;
    border-radius: 21px;
    background-color: #fff;
    padding: 23px;
    position: relative;

    &::after {
      content: "";
      display: block;
      position: relative;
      width: calc(100% + 4px);
      height: calc(100% + 4px);
      top: -2px;
      left: -2px;
      right: -2px;
      bottom: -2px;
      background: radial-gradient(circle at 60% 60%, #ffffff 0%, #F8E9E8 100%);

      z-index: 11;
      border-radius: 21px;
      padding: 5px;
      box-sizing: border-box;
    }

  }

  .box2 {
    width: calc(100% - 46px);
    height: 507px;
    background-color: #ffffff;
    position: absolute;
    z-index: 12;
    border-radius: 21px;
    padding: 55px 16px;

    .li-box {
      margin-top: 40px;

      .li {
        text-align: center;
        overflow: hidden;
        padding: 0 4px;

        img {
          height: 180px;
        }

        p.t1 {
          color: rgb(18, 18, 18);
          font-family: "PingFang SC";
          font-size: 24px;
          font-weight: 400;
          line-height: 36px;
          margin-top: 16px;
          word-wrap: normal;
        }

        .desc {
          padding-top: 12px;
          max-width: 270px;
          margin: 0 auto;

          p {
            color: rgb(119, 119, 119);

            font-size: 16px;
            font-weight: 400;
            line-height: 24px;
            letter-spacing: 1px;
          }
        }

      }
    }
  }
}

.swiper-btn {
  height: 44px;
  position: relative;
  top: -18px;
  z-index: 0;

  .swiper-button-prev,
  .swiper-button-next {


    &:hover {
      opacity: 0.8;
    }

    &::after {
      font-size: 13px;
      color: #9D9D9D;
    }

    width: 44px;
    height: 44px;
    background: rgb(234, 234, 234);
    border-radius: 50%;
    position: relative;
    right: auto;
    left: auto;
    top: auto;
    margin-top: 0;
    margin: 0 10px;
  }
}

.page-tab {
  span {
    width: 208px;
    height: 52px;
    line-height: 52px;
    border: 1px solid rgb(217, 217, 217);
    border-radius: 4px;
    padding-left: 20px;
    position: relative;
  }

  span {
    &::after {
      content: "";
      display: block;
      width: calc(100% + 0px);
      height: calc(100% + 0px);
      border-radius: 6px;
      border: 1px solid #B7251E;
      position: absolute;
      left: 0px;
      top: 0px;
      opacity: 0;
      transition: all .26s;

    }

    &::before {
      content: "";
      display: inline-block;
      width: 2px;
      height: 16px;
      border-radius: 1px;
      background: rgb(183, 37, 30);
      margin-right: 8px;
      position: relative;
      top: 1px;
    }
  }

  span:hover {
    &::after {
      content: "";
      opacity: 1;
      width: calc(100% + 6px);
      height: calc(100% + 6px);
      left: -4px;
      top: -4px;
    }
  }

  span.active:hover {
    &::after {
      display: none;
    }
  }

  span.active {
    width: 208px;
    height: 56px;
    border: none;
    background-image: url("../../assets/images/tab-bg.png");
    background-size: 100% 100%;
    padding-left: 44px;
    color: #FFFFFF;
    line-height: 56px;

    &::before {
      color: #FFFFFF;
      background: #ffffff;
      top: 2px;
    }
  }
}

.topcontent-page {
  background-image: url("../../assets/images/gezi.png");
  background-size: 100% auto;
  background-repeat: no-repeat;
  padding-top: 40px;

  .t1 {
    text-align: center;
    font-size: 28px;
    font-weight: 400;
    letter-spacing: 4px;
    line-height: 44px;
  }

  .t2 {
    font-family: "MicrosoftYaHeiSemibold";
    text-align: center;
    color: rgb(18, 18, 18);
    font-size: 50px;
    font-weight: 400;
    line-height: 60px;
    letter-spacing: 6px;
    margin-top: 4px;
  }

  .desc1 {
    color: rgb(76, 76, 76);
    font-size: 20px;
    font-weight: 400;
    line-height: 36px;
    letter-spacing: 1px;
    margin-top: 30px;
    // padding: 0 206px;
  }
}

.person-list {
  padding-top: 50px;
  overflow: hidden;
  max-width: 1792px;
  margin: 0 auto;
  // width: calc(100% + 48px);

  .list {
    width: 100%;
    // height: 460px;
    border: 1px solid transparent;
    background-color: #ffffff;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0px 8px 24px 0px rgba(0, 0, 0, 0.08);
    margin-right: 40px;
    margin-bottom: 40px;
    cursor: pointer;

    &:hover {
      .img-box img {
        transform: scale(1.1)
      }

      .name {
        color: #B7251E;
      }
    }

    &:nth-child(5n) {
      margin-right: 0;
    }

    .img-box {
      width: 100%;
      // height: 314px;
      padding-bottom: 99.33%;
      overflow: hidden;
      position: relative;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        position: absolute;
        transition: all 2s;
      }
    }

    .text-box {
      padding: 16px 24px 0;
      height: 171px;
    }

    .name {
      color: rgb(18, 18, 18);
      font-size: 22px;
      font-weight: 400;
      line-height: 28px;
    }

    .company {
      color: rgb(18, 18, 18);
      font-size: 16px;
      font-weight: 400;
      line-height: 22px;
      height: 22px;
      margin-top: 6px;
    }

    .desc {
      color: rgb(119, 119, 119);
      font-size: 14px;
      font-weight: 400;
      margin-top: 8px;
      line-height: 22px;
    }
  }
}
</style>